import { Checkbox, createTheme, FormControlLabel, Grid} from '@mui/material'
import React, { useEffect } from 'react'
import { customStyles } from '../../../styles'

import { ModalHeader } from '../../modals'
import { MainContainer } from '../../containers'
import { CaptionText, MainButton, MainInput, MainSelect } from '../../helpers'
import { useCustomForm } from '../../../hooks/useCustomForm'
import { useState } from 'react'
import { Map } from './Map'
import { useDispatch, useSelector } from 'react-redux'
import { newAccountAction } from '../../../actions/accountsAction'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { useNavigate } from 'react-router-dom'
import { Stack } from '@mui/system'
import { setError } from '../../../slices/statusSlice'
import { animations } from '../../../utils/animations'

export const AddNewAddressForm = React.forwardRef((props, ref) => {
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const { editMode, typeService:type } = useSelector(state => state.accounts)
   const autoFillAddress = useSelector(state => state.fillAddress)
   const { street, extNumber:extN, intNumber:intN, postalCode, colony, latitude, longitude} = autoFillAddress
   const [authorization] = useLocalStorage('login-token', null)
   const [activeFade, setActiveFade] = useState(false)
   const { inputValues, handleOnChange, setNewValues } = useCustomForm({
      intNumber: '',
      extNumber: '',
      reference: '',
      name: '',
      reciever: '',
   })
   
   const { reference, name, receiver, intNumber, extNumber } = inputValues

   const handleBackward = () => {
      navigate('/dashboard/accounts')
   }
   const handleSubmit = () => {
      if(street && name.length > 2 && receiver.length > 2 && postalCode.length === 5) {
         let address =  {
            street, extNumber, intNumber, postalCode, colony, latitude, longitude, reference
         }
         const form = {
            name, type, receiver,
            address: address
         }

         
         dispatch(newAccountAction(form, authorization?.token))
         setActiveFade(true)
         setTimeout(() => {
          navigate('/dashboard/guardando')
         }, 1000);
         
      } else {
         const payload = {
            message: 'Campos: dirección, nombre y quien recibe son obligatorios.',
            status: 0
          }
         dispatch(setError(payload))
      }
   }

   useEffect(() => {
      setNewValues({
         ...inputValues,
         intNumber: intN,
         extNumber: extN
      })
   }, [autoFillAddress])
   return (
      <MainContainer >
         <ModalHeader text="Agregar una dirección" bold color={customStyles.colors.main} backward action={handleBackward} />
         <Grid container spacing={2} className={ activeFade && animations.fadeOut } >
            <Grid item xs={12} >
               <Map />
               <CaptionText text="¿Tu dirección no coincide con el Pin del mapa?" underline color={customStyles.colors.main} />
            </Grid>

            <MainInput
           label="* Calle"
           name="street"
           value={street}
           onChange={handleOnChange}
           columns={12}
           disabled
           />
           <MainInput
              label="* No Ext"
              name="extNumber"
              value={extNumber}
              onChange={handleOnChange}
              columns={6}
           />
           <MainInput
              label="No Int"
              name="intNumber"
              value={intNumber}
              onChange={handleOnChange}
              columns={6}
           />
            <MainInput
               label="Referencia"
               name="reference"
               value={reference}
               onChange={handleOnChange}
               columns={12}
            />
            <MainInput
               label="* Alias"
               name="name"
               value={name}
               onChange={handleOnChange}
               columns={12}
            />
            <MainInput
               label="* Nombre de quien recibe"
               name="receiver"
               value={receiver}
               onChange={handleOnChange}
               columns={12}
            />
            <Grid item xs={12}>
               <FormControlLabel value={''} control={<Checkbox />} label="Usar como dirección de facturación"  />
            </Grid>
         </Grid>
         <Stack direction="row" spacing={3} className={ activeFade && animations.fadeOut }>

            <MainButton text="Cancelar" variant="outlined" size={customStyles.buttonSize.full} onClick={handleBackward} />

            <MainButton text={editMode ? 'Guardar cambios' : 'Guardar'} variant="contained" size={customStyles.buttonSize.full} onClick={handleSubmit}  />
         </Stack>
      </MainContainer>
   )
})
